export enum EPlanGroupWeekItemType {
  LessonTopic = 1,
  Text = 2,
  Video = 3,
}
